import React, { useState } from 'react';
import cn from 'classnames';

import { UiKit } from 'components';
import { useAccess } from 'utils/hooks';
import ModalContent from '../ModalContent';

/**
 * @param {object} props;
 * @param {(import('dictionary').FEATURE_SLUGS)} props.featureSlug Feature slug to check if user has access to the feature
 * @param {string} props.className
 * @param {import("react").ReactNode} props.fallback
 */
export default function ModalTrigger({
  featureSlug = '',
  className = '',
  fallback = null
}) {
  if (!featureSlug) {
    throw new Error(
      '"featureSlug" is a required prop in <ModalTrigger /> component'
    );
  }

  const { hasSubFeatureAccess } = useAccess();
  const [isOpen, setIsOpen] = useState(false);

  const hasAccess = hasSubFeatureAccess(featureSlug);

  if (hasAccess) return fallback;

  return (
    <>
      <UiKit.Button
        variant="outline"
        onClick={() => setIsOpen(true)}
        className={cn('w-100', className)}
      >
        View Details
      </UiKit.Button>
      <UiKit.Modal
        centered
        size="lg"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <UiKit.Modal.Body>
          <ModalContent featureSlug={featureSlug} />
        </UiKit.Modal.Body>
      </UiKit.Modal>
    </>
  );
}
